import { IntlShape, MessageDescriptor } from 'react-intl';

import messages from './messages';
import { AttributeScope, DynamicApproverRow } from './ruleForm';

/** What each attribute scope reads as: the condition builder's own words. */
export const ATTRIBUTE_SCOPE_LABELS: Record<AttributeScope, MessageDescriptor> =
  {
    opening: messages.attributeScopeOpening,
    location: messages.attributeScopeLocation,
    position: messages.attributeScopePosition,
  };

/**
 * What a dynamic approver row reads as wherever a rule names it: its chip in
 * the editor and its entry in the rules table. "Opening owner", or an
 * attribute and the entity it is read on, "HRBP Email (Opening)".
 *
 * A request reads the server's `source_label` instead, recorded at submission,
 * so a later edit to the rule leaves the request's wording as it was.
 *
 * @param attributeName the attribute's name, from the catalog or the rule's
 *   `attribute_label`; null when neither knows it
 */
export const dynamicApproverLabel = (
  intl: IntlShape,
  row: DynamicApproverRow,
  attributeName?: string | null,
): string => {
  if (row.approver_type !== 'attribute')
    return intl.formatMessage(messages.openingOwnerApprover);

  const scope = ATTRIBUTE_SCOPE_LABELS[row.attribute_scope];

  return intl.formatMessage(messages.attributeApprover, {
    attribute:
      attributeName || intl.formatMessage(messages.attributeApproverUnnamed),
    scope: scope ? intl.formatMessage(scope) : row.attribute_scope,
  });
};
